<template>
    <div class="pt-3">
        <div v-if="!isSubmited"> 
            <div class="text-center" style="width: 100%; max-width: 800px; margin: 0 auto;">
                <h5><strong>Tell Us About Your 3D Workflow</strong></h5>
                <p style="word-break: break-word;">We’d love to learn more about you! This survey explores your 3D field,
                    tools, working style, and experience with iRender, along with any feedback you’d like to share to help
                    us improve.</p>
            </div>
            <div class="mt-6" style="width: 100%; max-width: 800px; margin: 0 auto;">
                <div v-for="(surveyQuestion, ix) in surveyQuestions" :key="surveyQuestion.Id"
                    class="surveyQuestion-form-item">
                    <div class="question-wrapper" :class="{ 'has-error': surveyQuestion.errorValidate.length > 0 }">
                        <div class="mb-3"><strong>{{ ix + 1 }}. {{ surveyQuestion.Title }}</strong></div>
                        <div class="my-2">
                            <el-checkbox-group v-model="surveyQuestion.selectedOptionId"
                                @change="surveyQuestion.errorValidate = []">
                                <div class="d-flex flex-wrap">
                                    <div v-for="option in surveyQuestion.jsonOptions" :key="option.Id"
                                        style="flex: 0 0 25%;">
                                        <el-checkbox :label="option.Id">
                                            {{ option.Label }}
                                        </el-checkbox>
                                    </div>
                                </div>
                            </el-checkbox-group>
                            <div>
                                <div v-if="surveyQuestion.jsonOptions.length > 0" class="mb-1">Others</div>
                                <el-input v-if="surveyQuestion.jsonOptions.length > 0" v-model="surveyQuestion.others"
                                    @change="surveyQuestion.errorValidate = []"></el-input>
                                <el-input v-if="surveyQuestion.jsonOptions.length === 0" type="textarea"
                                    v-model="surveyQuestion.others" rows="3"
                                    @change="surveyQuestion.errorValidate = []"></el-input>
                            </div>
                        </div>
                        <div v-if="surveyQuestion.errorValidate.length > 0" class="text-danger">
                            {{ surveyQuestion.errorValidate[0] }}
                        </div>
                    </div>
                    <hr class="my-5" style="border-color: #f5f5f5;" />
                </div>
            </div>
            <div class="text-center mt-7">
                <button class="primary-button-style-2026 px-12 py-2" @click="submitForm()" type="button">
                    Submit
                </button>
            </div>
        </div>
        <div v-if="isSubmited"> 
            <div class="text-center" style="width: 100%; max-width: 800px; margin: 0 auto;">
                <div class="mb-5">
                    <img src="/img/checked.svg" height="50"/>
                </div>
                <h5><strong>Success! Your 30iRp Coupon is Ready!</strong></h5>
                <div class="mt-7"> 
                    <p style="word-break: break-word;">Thank you for completing the survey! Your feedback is invaluable to us.</p>
                    <p style="word-break: break-word;">A 30iR Coupon has been automatically added to your iRender account.</p>
                </div>
                <div>
                    <el-button @click="$router.push('/dashboard')">
                        Back to Dashboard
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import promotionApi from '@/api/promotionApi';
import { EXECUTE_RESULT } from "@/constant/baseConstant";
export default {
    props: {
        currentItem: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            isSubmited: false,
            isLoading: false,
            surveyQuestions: [],
        };
    },
    computed: {
        ...mapState({
            user: state => state.auth.user
        }),
    },
    mounted() {
        console.log("currentItem in popup: ", this.currentItem);
        this.getSurveyQuestion();
    },
    methods: {
        async getSurveyQuestion() {
            const refId = this.currentItem.referenceId;
            const res = await promotionApi.getSurveyQuestion(refId);
            if (res) {
                const data = res.data;
                if (data.result === EXECUTE_RESULT.SUCCESS) {
                    this.surveyQuestions = data.data.map(item => {
                        const { JsonOptions, ...rest } = item;
                        return {
                            ...rest,
                            jsonOptions: JSON.parse(JsonOptions || "[]"),
                            selectedOptionId: [], others: "",
                            errorValidate: [],
                        };
                    });
                }
            }
        },
        async submitCouponShowcase(payload) {
            this.isLoading = true;
            const res = await promotionApi.submitCouponShowcase(this.currentItem.code, payload);
            if (res) {
                const data = res.data;
                if (data.result === EXECUTE_RESULT.SUCCESS) {
                    this.$message.success("Submit successfully!");
                    this.isSubmited = true;
                    this.isLoading = false;
                    this.$emit('onRequestReloadList');
                } else {
                    this.$message.error(data.message || "Submit failed!");
                }
            }
        },
        submitForm() {
            let isValid = true;
            this.surveyQuestions.forEach(question => {
                const selected = Array.isArray(question.selectedOptionId)
                    ? question.selectedOptionId
                    : [];

                const hasOption = selected.length > 0;
                const hasOther = question.others && question.others.trim() !== '';

                if (!hasOption && !hasOther) {
                    question.errorValidate = [
                        "Please select at least one option or fill in the others field."
                    ];
                    isValid = false;
                } else {
                    question.errorValidate = [];
                }
            });
            if (!isValid) return;

            const payload = {
                couponVoucherId: this.currentItem.id,
                jsonAnswers: JSON.stringify(
                    this.surveyQuestions
                        .map(q => {
                            const selectedOptions = (q.selectedOptionId || [])
                                .map(id => {
                                    const opt = (q.jsonOptions || []).find(o => o.Id === id);
                                    return opt ? opt.Label : null;
                                })
                                .filter(Boolean);
                            const otherText = q.others && q.others.trim() !== '' ? q.others.trim() : null;
                            return {
                                questionId: q.Id,
                                selectedOptions: selectedOptions,
                                otherText: otherText
                            };
                        })
                ),
                refId: Number(this.currentItem.referenceId) || null,
            }; 
            this.submitCouponShowcase({
                ...payload
            });
            return true;
        }
    },
}
</script>